import {FC, PropsWithChildren} from 'react';
import {BoxProps, Container, ContainerProps} from '@mantine/core';
import {BreadcrumbPart, PageTitle} from './page-title.tsx';
import {isString} from '../utils/type-guards.ts';

type Props = {
  title?: string | BreadcrumbPart[];
  className?: string;
  maxWidth?: ContainerProps['size'];
} & BoxProps;

export const BasicPage: FC<PropsWithChildren<Props>> = (props) => {
  const {title = '', children, className, maxWidth = '1380px', ...rest} = props;
  const crumbs = isString(title) ? {title} : title;

  return (
    <Container p={32} size={maxWidth} className={className} {...rest}>
      <PageTitle crumbs={crumbs} />
      {children}
    </Container>
  );
};
